import gql from 'graphql-tag';

export const DEAL_EVENT_ACTIVITY_HUB_FRAGMENT = gql`
  fragment DealEventActivityHubFields on DealEventActivityViewModel {
    id
    type
    parentId
    allDay
    subject
    startAt
    startDate
    description
    activityStatus
    opportunityId

    participants {
      id
      fullName
      participationType
    }

    notes {
      id
      content
      createdDateTime
    }
  }
`;
